<!-- Installment Options -->
<div class="d-block justify-content-center px-1 mt-3 w-100 radionButtonsWrapper form-group">
    <p class="d-flex w-100 px-4 align-items-center fw-bold text-start text-gray fs-16">
        {{'OfferPage.SelectTenure' | translate}}
    </p>
    <div id="application-offer-installment-options" class="d-flex flex-wrap justify-content-center l-304">
        <div *ngFor="let tenure of tenures | slice:0: tenuresToShow" class="installment-option m-3">
            <input [value]="tenure?.Tenure" [disabled]="!tenure.Enabled" [(ngModel)]="selectedTenure" (ngModelChange)="tenureChanged()" id="insMonths{{tenure?.Tenure}}" type="radio" class="button-check" name="insMonthOptions" autocomplete="off">
            <label class="button button-radio text-black" for="insMonths{{tenure.Tenure}}" [class.disabled-option]="!tenure.Enabled">
                <span class="button-radioDot">&nbsp;</span>
                <div class="button-content d-flex flex-column">
                    <span class="title-month fs-12 fw-bold mb-1 text-gray text-center">
                        {{ "OfferPage.MonthlyTenure" | translate}}
                    </span>
                    <span class="value-month fs-16 mb-2 text-center fw-bold">
                        {{tenure?.Tenure}}
                    </span>
                    <span class="fs-12 fw-bold mb-1 text-center">
                        {{ "OfferPage.Installment" | translate }}
                    </span>
                    <span class="fs-16 text-center fw-bold Saudi_Riyal">
                        <span class="Saudi_Riyal fs-18 fw-normal d-block mb-2">
                            {{ "Currency.SAR" | translate }}
                        </span>
                        {{tenure.InstallmentAmount | currencyFormat}}
                    </span>
                </div>
            </label>
        </div>
    </div>
</div>

<ng-container *ngIf="fullLength > tenuresToShow" >
    <div class="w-100 d-flex mt-4 mb-4 justify-content-end">
        <a (click)="showAllTenures()" class="colored me-3" style="CURSOR: POINTER;">
            {{"Buttons.ViewMore" | translate }}
        </a>
    </div>
</ng-container>
<!-- end Installment options -->